import { Container } from 'react-bootstrap';
import './Footer.scss';

const Footer = () => {
  return <Container id="footer" className="container-fluid"></Container>;
};
export default Footer;
